import React from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

// img
import login1 from "../../../assets/images/login/1.jpg";
import login2 from "../../../assets/images/login/2.jpg";
import login3 from "../../../assets/images/login/3.jpg";

// Import selectors & action from setting store
import * as SettingSelector from "../../../store/setting/selectors";
// Redux Selector / Action
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword, reqResetPassword } from "../../../store/user/userThunk";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const Resetpassword = () => {
  const appName = useSelector(SettingSelector.app_name);
  let dispatch = useDispatch()
  const params = useParams();
  // Formik setup
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Required"),
    }),
    onSubmit: async (values) => {
      let id = params.id
      let data = {
        id: id,
        password: values?.password
      }
      dispatch(forgotPassword(data));
    },
  });

  return (
    <>
      <section className="sign-in-page">
        <Container fluid>
          <Row className="align-items-center">
            <Col md={6} className="overflow-hidden position-relative">
              <div className="bg-primary w-100 h-100 position-absolute top-0 bottom-0 start-0 end-0"></div>
              <div className="container-inside z-1">
                <div className="main-circle circle-small"></div>
                <div className="main-circle circle-medium"></div>
                <div className="main-circle circle-large"></div>
                <div className="main-circle circle-xlarge"></div>
                <div className="main-circle circle-xxlarge"></div>
              </div>
              <div className="sign-in-detail container-inside-top">
                <Swiper
                  className="list-inline m-0 p-0 "
                  spaceBetween={30}
                  centeredSlides={true}
                  loop={true}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                >
                  <ul className="swiper-wrapper list-inline m-0 p-0 ">
                    <SwiperSlide>
                      <img
                        src={login1}
                        className="signin-img img-fluid mb-5 rounded-3"
                        alt="images"
                      />
                      <h2 className="mb-3 text-white fw-semibold">
                        Power UP Your Friendship
                      </h2>
                      <p className="font-size-16 text-white mb-0">
                        It is a long established fact that a reader will be
                        <br /> distracted by the readable content.
                      </p>
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        src={login2}
                        className="signin-img img-fluid mb-5 rounded-3"
                        alt="images"
                      />
                      <h2 className="mb-3 text-white fw-semibold">
                        Connect with the world
                      </h2>
                      <p className="font-size-16 text-white mb-0">
                        It is a long established fact that a reader will be
                        <br /> distracted by the readable content.
                      </p>
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        src={login3}
                        className="signin-img img-fluid mb-5 rounded-3"
                        alt="images"
                      />
                      <h2 className="mb-3 text-white fw-semibold">
                        Together Is better
                      </h2>
                      <p className="font-size-16 text-white mb-0">
                        It is a long established fact that a reader will be
                        <br /> distracted by the readable content.
                      </p>
                    </SwiperSlide>
                  </ul>
                </Swiper>
              </div>
            </Col>
            <Col md={6}>
              <div className="sign-in-from">
                <Link to={"/"} className="d-inline-flex align-items-center justify-content-center gap-2">
                  <h2 className="logo-title" data-setting="app_name">{appName}</h2>
                </Link>
                <p className="mt-3 font-size-16">
                  Enter your new password and confirm it.
                </p>
                <Form className="mt-5" onSubmit={formik.handleSubmit}>
                  <Form.Group className="form-group text-start mb-0">
                    <h6 className="form-label fw-bold">Password</h6>
                    <Form.Control
                      type="password"
                      className="form-control mb-0"
                      placeholder="Enter new password"
                      {...formik.getFieldProps("password")}
                      isInvalid={!!formik.errors.password && formik.touched.password}
                    />
                    <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group text-start mb-0 mt-3">
                    <h6 className="form-label fw-bold">Confirm Password</h6>
                    <Form.Control
                      type="password"
                      className="form-control mb-0"
                      placeholder="Confirm new password"
                      {...formik.getFieldProps("confirmPassword")}
                      isInvalid={!!formik.errors.confirmPassword && formik.touched.confirmPassword}
                    />
                    <Form.Control.Feedback type="invalid">{formik.errors.confirmPassword}</Form.Control.Feedback>
                  </Form.Group>
                  <div className="d-flex mt-3">
                    <button type="submit" className="btn btn-primary">Reset Password</button>
                  </div>
                </Form>
                <div className="d-inline-block w-100 justify-content-between mt-4">
                  <Link to={"/auth/sign-in"}>Back to login</Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Resetpassword;
